/**
 * @file pageVisibleEvent
 */
import EventEmitter from '@baidu/event-emitter';
// import {parseJSON} from '@baidu/map-fe-utils';

class PageVisibleEvent extends EventEmitter {
    constructor() {
        super();
        this.init();
    }

    init() {
        /**
         * 端内页面可见性变化事件
         * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/HwaWZj7TWb/48VRcDMqEa/EKeWVsZCpeIfwY
         */
        Object.defineProperty(window, 'BMAP_PAGE_EVENT', {
            value: (res = '') => {
                let parseData = res;
                if (typeof res === 'string') {
                    // TODO: use parseJSON
                    parseData = JSON.parse(res);
                }
                const {enterOrLeavePage = 0} = parseData || {};
                if (Number(enterOrLeavePage) === 1) {
                    this.emit('page-hide'); // 派发页面不可见事件（跳页、压后台、息屏、kill app等）
                }
                else {
                    this.emit('page-show'); // 派发页面可见事件（用户视角）
                }
            },
            writable: false,
            configurable: false
        });

        // TODO: 后续可以扩展H5原生的可见性变化事件监听，用于端外场景使用
    }
}

export default (new PageVisibleEvent());